
import 'owl.carousel';
import "./fancybox/fancybox-4.css";
import "./fancybox/fancybox-4.js";
import './jquery.mask';
import './custom.js';
// import 'jquery/dist/jquery'
// let $ = jQuery;
import '@fortawesome/fontawesome-free/js/all.js'
import '../scss/main.scss';
import '../index.html';




















































